import { Toaster } from 'sonner';
import { useIsMobile } from '@/hooks/useIsMobile';

export function AppToaster() {
  const isMobile = useIsMobile();

  return (
    <Toaster
      position={isMobile ? 'top-center' : 'bottom-right'}
      offset={isMobile ? 16 : 16}
      richColors
      toastOptions={{
        className:
          'border !border-slate-200 dark:!border-charcoal-700 !shadow-[0_8px_24px_-8px_rgba(15,23,42,0.18)]',
        style: { borderRadius: '0.5rem' },
      }}
    />
  );
}
